import { render, staticRenderFns } from "./DownloadManagement.vue?vue&type=template&id=9a035362&scoped=true"
import script from "./DownloadManagement.vue?vue&type=script&lang=js"
export * from "./DownloadManagement.vue?vue&type=script&lang=js"
import style0 from "./DownloadManagement.vue?vue&type=style&index=0&id=9a035362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a035362",
  null
  
)

export default component.exports